import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantUserService, AppDataService, StoreService } from 'app/services';
import { PartnerMartLocationsHoursComponent, PartnerMartLocationsStoreHoursComponent } from 'app/partner';
import { OperationHour, SpecialHour } from 'app/models';
import { Utils } from 'app/utils';
import moment from 'moment';
import { cl } from '@fullcalendar/core/internal-common';

@Component({
    selector: 'partner-mart-locations-sidebar-hours',
    templateUrl: './partner-mart-locations-sidebar-hours.component.html',
    styleUrls: ['./partner-mart-locations-sidebar-hours.component.scss',
        '../../../../../../../styles/sidebar.scss',
        '../../../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class PartnerMartLocationsSidebarHoursComponent implements OnInit {
    @Input() public showStoreHourSideBar: boolean = false;

    @Input()
    public store: any = {};

    @Input() public partnerMartLocationsStoreHoursComponent!: PartnerMartLocationsStoreHoursComponent;

    public operationHours: OperationHour[] = [new OperationHour()];
    public specialHours: SpecialHour[] = [new SpecialHour()];

    @Output() changedShowStoreHourSideBarEmit = new EventEmitter<boolean>();
    changedShowStoreHourSideBar(increased: any) {
        this.changedShowStoreHourSideBarEmit.emit(increased);
    }

    @ViewChild(PartnerMartLocationsHoursComponent, { static: false })
    private partnerMartLocationsHours?: PartnerMartLocationsHoursComponent;

    public loading: boolean = false;

    constructor(private messageService: MessageService, private merchantUserService: MerchantUserService,
        public appData: AppDataService, private storeService: StoreService) {
    }

    ngOnInit(): void {
        this.storeFields();
    }

    updateStore() {
        if (!this.partnerMartLocationsHours) {
            console.error('partnerMartLocationsHours not found');
            return;
        }

        this.loading = true;

        // OperationHours
        this.operationHours = this.partnerMartLocationsHours.getOperationHours();
        this.store.StoreOperationHours = this.partnerMartLocationsHours.getOperationHoursDto();

        // SpecialHours
        this.specialHours = this.partnerMartLocationsHours.getSpecialHours();
        this.store.StoreSpecialHours = this.partnerMartLocationsHours.getSpecialHoursDto();

        this.store.TimeZoneOffSet = Utils.getTimezoneOffset();

        this.storeService.editStore(this.store, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data saved successfully' });
                this.partnerMartLocationsStoreHoursComponent.getStore();
                this.cancel();
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    storeFields() {
        console.log(this.store);
        // OperationHours
        this.operationHours = [];
        if (!this.store.OperationHourItems || !this.store.OperationHourItems.length) {
            this.operationHours.push(new OperationHour());
        }
        else {
            this.store.OperationHourItems.forEach((obj: any) => {
                this.operationHours.push({
                    SelectedDaysWeek: obj.DayOfWeeks,
                    SelectStartTime: new Date(obj.StartTime), SelectStartTimeIsEmpty: false,
                    SelectEndTime: new Date(obj.EndTime), SelectEndTimeIsEmpty: false,
                });
            });
        }

        // SpecialHours
        this.specialHours = [];

        if (!this.store.StoreSpecialHours || !this.store.StoreSpecialHours.length) {
            this.specialHours.push(new SpecialHour());
        }
        else {
            this.store.StoreSpecialHours.forEach((obj: any) => {
                const specialHour: SpecialHour = {
                    Title: obj.Title,
                    StartDate: new Date(obj.StartDate),
                    EndDate: new Date(obj.EndDate),
                    IsOpen: obj.IsOpen,
                    StoreSpecialHourTimes: []
                };

                if (!obj.StoreSpecialHourTimes || !obj.StoreSpecialHourTimes.length) {
                    specialHour.StoreSpecialHourTimes.push({
                        OpensAt: null,
                        ClosesAt: null
                    });
                }
                else {
                    obj.StoreSpecialHourTimes.forEach((time: any) => {
                        specialHour.StoreSpecialHourTimes.push({
                            OpensAt: new Date(time.OpensAt),
                            ClosesAt: new Date(time.ClosesAt)
                        });
                    });
                }

                this.specialHours.push(specialHour);
            });
        }
    }

    cancel() {
        this.changedShowStoreHourSideBar(false);
    }
}
